import api from './api';

const UserService = {
    // Profile
    getProfile: async () => {
        return api.get('users/me/');
    },

    updateProfile: async (data) => {
        // Data likely contains { first_name, last_name, phone, profile: { avatar..., bio... } }
        // The backend `update_profile` action on ViewSet updates the `UserProfile` model.
        // But basic user info (first_name, last_name) is on User model.
        // Backend `UserViewSet` has standard `update`/`partial_update`.
        // Let's assume we use standard PATCH /users/{id}/ for User model fields
        // And /users/update_profile/ for Profile model fields.
        // Actually, looking at backend `UserViewSet`, `update_profile` only updates `request.user.profile`.
        // `UserSerializer` is read-only for `profile` usually or nested.
        // Let's try updating user standard fields via PATCH /users/{id}/ first.
        // Since we don't easy access ID in service without passing it... let's rely on `users/me/` if it exists?
        // No `users/me` is GET only in the code I saw.
        // Wait, standard `partial_update` requires ID.
        // Let's assume we pass ID.
        return api.patch(`users/${data.id}/`, data);
    },

    updateUserProfileDetails: async (data) => {
        // This targets the /users/update_profile/ endpoint for extra fields
        return api.patch('users/update_profile/', data, {
            headers: { 'Content-Type': 'multipart/form-data' } // In case of avatar
        });
    },

    // Addresses
    getAddresses: async () => {
        return api.get('addresses/');
    },

    addAddress: async (data) => {
        return api.post('addresses/', data);
    },

    updateAddress: async (id, data) => {
        return api.put(`addresses/${id}/`, data);
    },

    deleteAddress: async (id) => {
        return api.delete(`addresses/${id}/`);
    },

    setDefaultAddress: async (id) => {
        return api.post(`addresses/${id}/set_default/`);
    },

    // Saved Cards
    getSavedCards: async () => {
        return api.get('payments/saved-cards/');
    },

    deleteSavedCard: async (id) => {
        return api.delete(`payments/saved-cards/${id}/`);
    },

    // Security
    changePassword: async (data) => {
        // Backend typically uses djoser or custom endpoint. 
        // I notice `users/set_password/` action or similar is common. 
        // Looking at backend `UserViewSet`, I didn't see explicit change password action in the snippet.
        // Standard djoser/simplejwt layout often has it. 
        // Let's check `users/urls.py` if I could... but for now assume standard djoser path `users/set_password/` 
        // OR `users/me/` PATCH? No. 
        // If it's missing, I might need to add it or use a placeholder.
        // Let's assume standard `api/v1/users/set_password/` if using Djoser.
        // If not using Djoser, I need to implement it.
        // The backend scan showed `CustomTokenObtainPairView`, so likely custom auth.
        // I should have checked for `set_password` action. 
        // I will check `backend/seeker/apps/users/views.py` again or `urls.py` if I need to add it.
        // For now, I'll put a placeholder.
        return api.post('users/set_password/', data);
    }
};

export default UserService;
